module.exports = fox._r("fonts/museosanscyrl_0-webfont.ttf", __webpack_public_path__ + "fonts/1UkRIWl.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl_0-webfont.ttf
// module id = 579
// module chunks = 2